(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/eid-sign/assets/javascripts/constants.js') >= 0) return;  svs.modules.push('/components/app/eid-sign/assets/javascripts/constants.js');
"use strict";


const constants = svs => {
  'use strict';

  svs.app.eidSign.constants = {
    MODE: {
      BANKID: 'bankid',
      FREJA: 'frejaeid'
    }
  };

  svs.app.eidSign.bankid.constants = {
    CUSTOMER_IDENTIFY_TIMEOUT: 49,
    CUSTOMER_SCAN_TIMEOUT: 56,
    INITIAL_QRCODE_RETRIES: 9 
  };

  svs.app.eidSign.freja.constants = {
    AUTHREF_NOT_FOUND_OR_EXPIRED: 71,
    MAXPOLLING_ATTEMPTS: 30,
    INITIAL_QRCODE_RETRIES: 9 
  };
};
constants(svs);

 })(window);